<template>
  <div>
    <v-card class="ma-1" max-width="100%">
      <v-row>
        <v-card-title class="primary--text mt-3"
          ><div v-if="tab == 0">
            <v-btn @click="$refs.goback.callstatus()" class="ml-n2 primary--text" text v-if="showval == true">
            <v-icon>mdi-reply</v-icon></v-btn
          >
            <v-btn @click="back" class="ml-n2 primary--text" text v-else>
            <v-icon>mdi-reply</v-icon></v-btn
          >
          
          </div>
          <div v-if="tab == 1">
            <v-btn @click="$refs.goback2.callstatus()" class="ml-n2 primary--text" text v-if="showval2 == true">
            <v-icon>mdi-reply</v-icon></v-btn
          >
            <v-btn @click="back" class="ml-n2 primary--text" text v-else>
            <v-icon>mdi-reply</v-icon></v-btn
          >
          </div>
          <div v-if="tab == 2">
            <v-btn @click="$refs.goback3.callstatus()" class="ml-n2 primary--text" text v-if="showval3 == true">
            <v-icon>mdi-reply</v-icon></v-btn
          >
            <v-btn @click="back" class="ml-n2 primary--text" text v-else>
            <v-icon>mdi-reply</v-icon></v-btn
          >
          
          </div>
       Expense Approval
          <span
            style="
              font-style: italic;
              font-family: Times New Roman;
              font-size: 14px;
            "
            class="text-left font-weight: 20 primary--text ml-2"
            >(Card Users Expense Approval)</span
          ></v-card-title
        >
      </v-row>
      <v-tabs
        v-model="tab"
        background-color="transparent"
        color="primary"
        grow
        class="ml-n3"
      >
        <v-tab v-for="item in tabItems" :key="item" name="item"
          >{{ item }}
          <v-badge
            v-if="
              expensecount1 != null &&
              expensecount1 != '0' &&
              item == 'Approver 1'
            "
            :content="expensecount1"
            value="expensecount1"
            color="gold "
            class="mt-3 ml-3"
          >
          </v-badge>
          <v-badge
            v-if="
              expensecount2 != null &&
              expensecount2 != '0' &&
              item == 'Approver 2'
            "
            :content="expensecount2"
            value="expensecount2"
            color="gold "
            class="mt-3 ml-3"
          >
          </v-badge
        ></v-tab>
      </v-tabs>
    </v-card>

    <Verify v-if="tab == 0" @Showvalue="Showvalue"  ref="goback"/>

    <ExpensePending v-if="tab == 1"  @Showvalue2="Showvalue2" ref="goback2"/>

    <ExpenseHistory v-if="tab == 2" @Showvalue3="Showvalue3" ref="goback3" />
    
  </div>
</template>
<script>
import Verify from "@/components/ExpenseSubFol/Verify.vue";
import ExpensePending from "@/components/ExpenseSubFol/ExpensePending.vue";
import ExpenseHistory from "@/components/ExpenseSubFol/ExpenseHistory.vue";


import { apiCall } from "@/Views/APICALL/APIcall.js";
export default {
  components: {
    Verify,
    ExpensePending,
    ExpenseHistory,
  
  },
  data: () => ({
    tab: "",
    showval:false,
    tabItems: ["Approver 1", "Approver 2", "History"],
    Show:false,
    showval2:false,
    showval3:false,

  }),
  mounted(){
    this.showval = false
   
  },
  computed: {
    expensecount1() {
      return this.$store.getters.get_ExpenseCount1;
    },
    expensecount2() {
      return this.$store.getters.get_ExpenseCount2;
    },
  },
  methods: {
    back() {   
        this.$router.push("/Dashboard");
    },
    async getcountNotification() {
      var inputData = {
        method_name: "ADMINCORP",
        page_no: 1,
        record_count: 0,
        page_size: null,
        app_code: "APORTAL",
        method_param: {
          action: "BADGES",
          module_type: 2,
          corp_id: this.$store.getters.get_corpid,
          logged_user_id: this.$store.getters.get_userid,
        },
      };

      var responseData = await apiCall(inputData);

      for (let i = 0; i < responseData.data.data.length; i++) {
        switch (responseData.data.data[i].module_code) {
          case "CARDFUNDS":
            this.corpcount = responseData.data.data[i].count;
            this.$store.commit("SET_FundCount", this.corpcount);
            break;
          case "EXMGMT1":
            this.expensecount1 = responseData.data.data[i].count;
            this.$store.commit("SET_ExpenseCount1", this.expensecount1);
            break;
          case "EXMGMT2":
            this.expensecount2 = responseData.data.data[i].count;
            this.$store.commit("SET_ExpenseCount2", this.expensecount2);
            break;
          case "EXRVRY":
            this.expenserecover = responseData.data.data[i].count;
            this.$store.commit("SET_ExpenseRecoverCount", this.expenserecover);
            break;
        }
      }
    },
    Showvalue(data){
      this.showval = data;
    },
    Showvalue2(data){
      this.showval2 = data
    },
    Showvalue3(data){
      this.showval3 = data
    }
    
  },
};
</script>
<style scoped></style>
